export enum SettingsSectionControl {
  ModerationType = 'moderationType',
  CommentVisibility = 'commentVisibility',
  ModeratorComments = 'moderatorComments',
}
